exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17jt44bnhCMWwWmWllikK{height:90vh;width:90vw}._2vz9PW3Bskt43FqO0g76j-{height:100%}._2Rv5hEW-aJsAvu5uzFBnuO{display:-webkit-box;display:-ms-flexbox;display:flex;min-width:100%;height:calc(100% - 40px)}html[dir] ._2Rv5hEW-aJsAvu5uzFBnuO{padding:0}._2flAQuO2CTrERF_uMJyNT5{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}", ""]);

// exports
exports.locals = {
	"modalContainer": "_17jt44bnhCMWwWmWllikK",
	"filePickerContent": "_2vz9PW3Bskt43FqO0g76j-",
	"content": "_2Rv5hEW-aJsAvu5uzFBnuO",
	"filePickerPane": "_2flAQuO2CTrERF_uMJyNT5"
};